// extracted by mini-css-extract-plugin
export var body = "_e9-0";
export var sectionHeader = "_e9-4";
export var shortcutColumns = "_e9-2";
export var shortcutList = "_e9-1";
export var shortcutSection = "_e9-3";